module.exports = __webpack_public_path__ + "fj.49f9fa66.svg";